import { REACT_QUERY_KEYS } from '@/constants'

export const shipmentCategoriesQueryKeys = {
  all: [REACT_QUERY_KEYS.SHIPMENT_CATEGORIES] as const,
  select: (tenantKey: string, dcId?: number, shippingDate?: string) =>
    [
      ...shipmentCategoriesQueryKeys.all,
      'select',
      tenantKey,
      dcId,
      shippingDate
    ] as const
}
